import * as yup from "yup";
import { t } from "@/i18n-js/instance";

const localeNamespace = "settings.emails.templates";
const NAME_MAX_LENGTH = 140;

const templateNameSchema = yup
  .string()
  .trim()
  .max(
    NAME_MAX_LENGTH,
    t([localeNamespace, "template_name_too_long"], {
      numOfCharacters: NAME_MAX_LENGTH,
    }),
  )
  .required(t([localeNamespace, "template_name_required"]));

export const createTemplateValidationSchema = yup.object().shape({
  name: templateNameSchema,
});
